module.exports = ":host{z-index:1}\n"